module.exports = __webpack_public_path__ + "img/gears-icon.08ffb152.svg";